/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Input,
  ConfigProvider,
  Image,
  Form,
  Divider,
  Typography,
  // Flex,
  Avatar,
  Tooltip,
} from "antd";
import {
  UserAddOutlined,
  UserOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import Timer from "otp-timer";
import PropTypes from "prop-types";
//components
// import Logo from "../../assets/images/sidebar-logo.png";
import createLogo from "../../assets/images/logo-main.png";
// import createLogo from "../../assets/images/logo.png";

import "./auth.css";
import TinyColor from "@ctrl/tinycolor";
import { emailIsValid, phoneIsValid } from "./validations";
// import LinkedAnimate from "../../components/Animation";
import arrow from "../../assets/images/arrow-1.png";
import SimpleReactValidator from "simple-react-validator";
import { isEmpty } from "lodash";
import { useHistory } from "react-router";
import api, { setAuthToken } from "../../helpers";
import { MetaTags } from "react-meta-tags";

const { Title } = Typography;

const Register = (props) => {
  //State maintenance
  const [otpValue, setOtpValue] = useState("");
  const [locationPosition, setLocationPosition] = useState({
    latitude: "",
    longitude: "",
  });
  const [getOtp, setGetOtp] = useState(false);
  const [loader, setLoader] = useState(false);
  const [createloader, setCreateLoader] = useState(false);
  const [error, setError] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [fieldsValidated, setFieldsValidated] = useState(false);
  const [userValue, setUserValue] = useState("");
  const [userId, setUserId] = useState("");

  //validations
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(function (position) {
      setLocationPosition({
        ...locationPosition,
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      });
    });
    if (navigator.geolocation) {
      navigator.permissions
        .query({ name: "geolocation" })
        .then(function (result) {});
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const history = useHistory();
  //validation change
  const validationChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-input");
    const current_value = inputValue.replace(/ /g, "");
    setUserValue(current_value);
    if (!phoneIsValid(current_value) && !emailIsValid(current_value)) {
      document.getElementById("error-panel").style.display = "block";
      mainInput.value = current_value;
    } else {
      document.getElementById("error-panel").style.display = "none";
      if (phoneIsValid(current_value)) {
        const phoneNumberArr = [...current_value.matchAll(/\d{2}/g)].map(
          (x) => x["0"]
        );
        mainInput.value = phoneNumberArr.join(" ");
        setFieldsValidated(true);
      }
    }
  };

  //OnChange
  const onChange = (text) => {
    setOtpValue(text);
  };
  // const handleClick = (text) => {
  //   console.log("onClick:", text);
  // };
  const sharedProps = {
    onChange,
  };
  const [otpButtonDisabled, setOtpButtonDisabled] = useState(false);
  const [signUpButtonDisabled, setSignUpButtonDisabled] = useState(false);
  //signUp functionality
  const otpValidations = () => {
    if (simpleValidator.current.allValid()) {
      setSignUpButtonDisabled(true);
      setTimeout(() => {
        setSignUpButtonDisabled(false);
      }, 4000);
      const user = {
        mobileNo: userValue,
        // otp: otpValue,
      };
      api
        .post("/auth/users/register", user)
        .then((res) => {
          setUserId(res.data.userId);
          setGetOtp(true);
          setOtpSent(true);
          setError("");
          setLoader(true);
          setTimeout(() => {
            setLoader(false);
          }, 2000);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message);
          setError(errorMsg);
          setGetOtp(false);
          setOtpSent(false);
          setLoader(true);
          setTimeout(() => {
            setLoader(false);
          }, 2000);
          Promise.reject(error);
        });
      // history.push("/user-details");
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  const signUp = () => {
    if (simpleValidator.current.allValid()) {
      setOtpButtonDisabled(true);
      setTimeout(() => {
        setOtpButtonDisabled(false);
      }, 4000);
      const user = {
        userId: userId,
        // "otp": "228100",
        latitude: locationPosition.latitude,
        longitude: locationPosition.longitude,
        // email: userValue,
        otp: otpValue,
      };
      api
        .post("/auth/users/otpverification", user)
        .then((res) => {
          // setUserId(res.data);
          setAuthToken(res.data.token);
          setError("");
          setCreateLoader(true);
          setTimeout(() => {
            setCreateLoader(false);
          }, 2000);
          localStorage.setItem("authToken", res.data.token);
          localStorage.setItem("user", res.data);
          localStorage.setItem("authData", JSON.stringify(res.data));
          history.push({ pathname: "/user-details", state: res.data.user });
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message);
          setError(errorMsg);
          setCreateLoader(true);
          setTimeout(() => {
            setCreateLoader(false);
          }, 2000);
          Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  //otp condition false
  useEffect(() => {
    if (getOtp === true) {
      setTimeout(() => {
        setGetOtp(false);
      }, 45000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getOtp]);
  const otpInputRef = useRef(null);
  useEffect(() => {
    if ((getOtp && fieldsValidated) || (getOtp && otpSent)) {
      setTimeout(() => {
        otpInputRef.current?.focus(); // Ensure focus on the OTP input field
      }, 100);
    }
  }, [getOtp, fieldsValidated, otpSent]);

  //button styles

  const getHoverColors = (colors) =>
    colors.map((color) => new TinyColor(color).lighten(5).toString());
  const getActiveColors = (colors) =>
    colors.map((color) => new TinyColor(color).darken(5).toString());

  const colors1 = ["#6253E1", "#04BEFE"];

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Create Account | Mbook</title>
        </MetaTags>
      </div>
      <div className="register-main-card">
        <div className="register-main">
          <div className="register-grid">
            <div className="register-form-inputs">
              <div className="md:text-start lg:text-start text-center xl:text-start xxl:text-start mb-2">
                {/* <Image src={Logo} preview={false} height={50} width={320} /> */}
                <Image
                  src={createLogo}
                  preview={false}
                  // height={65}
                  width={150}
                />
              </div>
              <div
                style={{
                  fontFamily: "Poppins",
                }}
                className="mb-2 text-[black] text-start"
              >
                <h1 className="flex text-[black] text-[20px] font-semibold">
                  Get started with your email or phone number
                  {/* Get started with your email or phone number */}
                </h1>
              </div>
              <Typography className="mt-4 mb-1 text-[red] text-[13px] text-center">
                {!isEmpty(error) && error ? error : ""}
              </Typography>
              <Form.Item name="userValue" className="mt-2 mb-3">
                <Input
                  className="p-1.5"
                  id="main-input"
                  name="userValue"
                  maxLength={fieldsValidated === true ? 10 : 30}
                  value={userValue}
                  placeholder="Mobile or Email"
                  onChange={validationChange}
                  style={{
                    fontFamily: "Poppins",
                  }}
                />
                <p className="text-start text-[red] mt-2 mb-3">
                  {simpleValidator.current.message(
                    "Email or mobile",
                    userValue,
                    "required"
                  )}
                </p>
              </Form.Item>
              <div
                id="error-panel"
                style={{
                  display: "none",
                  marginTop: "-15px",
                  marginBottom: "10px",
                }}
              >
                {isEmpty(userValue) ? (
                  ""
                ) : (
                  <p className="text-start text-[12px] text-[#ff0000]">
                    The email or mobile field is not valid
                  </p>
                )}
              </div>
              {(fieldsValidated && getOtp) || otpSent === true ? (
                ""
              ) : isEmpty(userValue) ? (
                <div className="text-center mt-[20px] w-[100%]">
                  <Button
                    type="primary"
                    className="w-[100%] p-3 hover:none auth-login-label"
                    // disabled={
                    //   // fieldsValidated
                    //   //   ? true
                    //   isEmpty(error)
                    //     ? false
                    //     :
                    //     ? true
                    //     : false
                    // }
                    disabled={signUpButtonDisabled ? true : false}
                    onClick={() => otpValidations()}
                  >
                    {loader ? "Loading..." : "Get OTP"}
                  </Button>
                </div>
              ) : (
                <div className="text-center mt-[20px] w-[100%]">
                  <Button
                    type="primary"
                    disabled={signUpButtonDisabled ? true : false}
                    className="w-[100%] p-3 hover:none auth-login-label"
                    onClick={() => otpValidations()}
                  >
                    {loader ? "Loading..." : "Get OTP"}
                  </Button>
                </div>
              )}

              {getOtp == true && fieldsValidated ? (
                <div className="mt-2">
                  <Timer
                    textColor={"#ff4d4f"}
                    seconds={45}
                    minutes={0}
                    // buttonColor={'red'}
                    background={"none"}
                    // text={`OTP sent to you via sms or e-mail`}
                    text={`Entered OTP sent to you mobile or email - `}
                    // resend={handleClick}
                  />
                </div>
              ) : (
                ""
              )}
              {fieldsValidated && otpSent ? (
                <p
                  className="auth-login-label cursor-pointer text-[black] text-[14px] underline"
                  onClick={() => otpValidations()}
                >
                  Resend OTP
                </p>
              ) : (
                ""
              )}
              {getOtp == true && fieldsValidated ? (
                <div className="ml-2 w-[100%]">
                  <div className="mt-5">
                    <Title level={6}></Title>
                    <Input.OTP
                      ref={otpInputRef}
                      formatter={(str) => str.toUpperCase()}
                      {...sharedProps}
                    />
                  </div>{" "}
                </div>
              ) : (
                ""
              )}
              {getOtp == true && fieldsValidated ? (
                <ConfigProvider
                  theme={{
                    components: {
                      Button: {
                        colorPrimary: `linear-gradient(116deg,  ${colors1.join(
                          ", "
                        )})`,
                        colorPrimaryHover: `linear-gradient(116deg, ${getHoverColors(
                          colors1
                        ).join(", ")})`,
                        colorPrimaryActive: `linear-gradient(116deg, ${getActiveColors(
                          colors1
                        ).join(", ")})`,
                        lineWidth: 0,
                      },
                    },
                  }}
                >
                  <Button
                    className={
                      // getOtp && fieldsValidated
                      //   ?
                      "mt-[30px] p-5 w-[100%] auth-login-label"
                      // : "pointer-events-none opacity-25 mt-[30px] p-5 w-[100%]"
                    }
                    type="primary"
                    // htmlType="submit"
                    htmlType="submit"
                    disabled={otpButtonDisabled ? true : false}
                    // disabled={getOtp && fieldsValidated ? false : true}
                    onClick={signUp}
                    icon={<UserAddOutlined />}
                    // href={getOtp && fieldsValidated ? "/dashboard" : "#"}
                  >
                    {createloader ? "Loading..." : "Create Account"}
                  </Button>
                </ConfigProvider>
              ) : (
                ""
              )}
              <Divider style={{ fontWeight: 600, marginTop: "20px" }}>
                {" "}
                <SafetyCertificateOutlined className="auth-login-label" /> 100%
                secure
              </Divider>
              <div className="">
                {/* <div className="flex justify-center mt-[40px] w-[46%]"> */}
                <div className="flex justify-center md:mt-[35px] lg:mt-[35px] text-center xl:mt-[35px] xxl:mt-[35px] mt-[20px] w-[100%]">
                  <Button
                    type="dashed"
                    className="w-[40%] p-3 hover:none auth-login-label"
                    onClick={() => history.push("/login")}
                  >
                    Login
                  </Button>
                </div>
                <div className="flex justify-center text-[black] mt-[10px] text-[16px] w-[100%]">
                  Or
                </div>
                <div className="flex justify-center mt-[10px] w-[100%]">
                  <Button
                    type="dashed"
                    className="w-[40%] p-3 hover:none auth-login-label"
                    onClick={() => history.push("/employee-login")}
                  >
                    Employee Login
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="login-image">
            <div className="login-image-content">
              <h1 className="login-image-content-text text-start leading-none font-[700]">
                Welcome to <br /> our community
              </h1>
              <p className=" text-[18px] text-start leading-tight text-[lightgray] mt-3">
                Personalised, update daily and beautifully presented. <br />{" "}
                Create account to find your dream new home and get full <br />{" "}
                access to platform's functionality.
              </p>
            </div>
            <div className="flex">
              <Avatar.Group className="avatar-card">
                <Avatar src="https://api.dicebear.com/7.x/miniavs/svg?seed=1" />
                <a href="https://ant.design">
                  <Avatar
                    style={{
                      backgroundColor: "#f56a00",
                    }}
                  >
                    K
                  </Avatar>
                </a>
                <Tooltip title="User" placement="top">
                  <Avatar
                    style={{
                      backgroundColor: "#87d068",
                    }}
                    icon={<UserOutlined />}
                  />
                </Tooltip>
                <Avatar
                  style={{
                    backgroundColor: "#1677ff",
                  }}
                  icon={<UserOutlined />}
                />
              </Avatar.Group>
              <p className="ml-[10px] mt-3 text-[14px] text-[lightgray]">
                4k+ customers joined with us, now it's your turn
              </p>
            </div>

            <div className="image-arrow">
              <Image
                src={arrow}
                preview={false}
                width={230}
                color="white"
                className="text-[black]"
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

Register.propTypes = {
  onSignin: PropTypes.any,
};

export default Register;
